(() => {
'use strict';
const $ = (s, r = document) => r.querySelector(s), $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
const THANKS = '/?view=lf-thank-you';
const SERVICES = [['Live Smoothie Bar', 'Live smoothie bar'], ['Catering', 'Catering'], ['Wholesale Smoothie Supply', 'Wholesale'], ['Fundraising enquiry', 'Fundraising'], ['Other', 'Other']];
const LEGACY = { 'Schools': 'Fundraising enquiry', 'Frozen Smoothie Packs': 'Wholesale Smoothie Supply', 'Live Smoothie Bar': 'Live Smoothie Bar', 'Catering': 'Catering', 'Wholesale Smoothie Supply': 'Wholesale Smoothie Supply', 'Fundraising enquiry': 'Fundraising enquiry', 'Other': 'Other' };
function normaliseSelects() {
  $$('select[name="contact[service]"]').forEach(sel => {
    if (sel.dataset.lf === '1') return;
    const chosen = (sel.options[sel.selectedIndex] || {}).value || '';
    let current = LEGACY[chosen] || 'Other';
    if (document.body.dataset.page === 'Schools') current = 'Fundraising enquiry';
    sel.innerHTML = SERVICES.map(([v, l]) => `<option value="${v}"${v === current ? ' selected' : ''}>${l}</option>`).join('');
    sel.dataset.lf = '1';
  });
}
normaliseSelects();
document.addEventListener('click', e => {
  if (!e.target.closest('[data-inquire],[data-use]')) return;
  setTimeout(() => { $$('select[name="contact[service]"]').forEach(sel => { if (sel.selectedIndex < 0 || !sel.value) sel.value = 'Fundraising enquiry'; }); }, 0);
});
if (/contact_posted=true/.test(location.search) || $('.form-success')) { location.replace(THANKS); }
$$('form[action*="/contact"]').forEach(f => {
  if (!f.querySelector('input[name="return_to"]')) { const h = document.createElement('input'); h.type = 'hidden'; h.name = 'return_to'; h.value = THANKS; f.appendChild(h); }
});
const mq = $('.lf-marquee');
if (mq) {
  const btn = $('.lf-marquee-pause');
  if (btn) btn.addEventListener('click', () => { const p = mq.dataset.paused !== 'true'; mq.dataset.paused = String(p); btn.textContent = p ? 'Resume logos' : 'Pause logos'; btn.setAttribute('aria-pressed', String(p)); });
}
const root = $('#lf-shop');
if (!root) return;
const FSA = new Set('L1E L1G L1H L1J L1K L1L L1M L1N L1P L1R L1S L1T L1V L1W L1X L1Z L3L L3P L3R L3S L3T L3X L3Y L4B L4C L4E L4G L4H L4J L4K L4L L4S L4T L4V L4W L4X L4Y L4Z L5A L5B L5C L5E L5G L5H L5J L5K L5L L5M L5N L5P L5R L5S L5T L5V L5W L6A L6B L6C L6E L6G L6H L6J L6K L6L L6M L6P L6R L6S L6T L6V L6W L6X L6Y L6Z L7A L7L L7M L7N L7P L7R L7S L7T M0R M1B M1C M1E M1G M1H M1J M1K M1L M1M M1N M1P M1R M1S M1T M1V M1W M1X M2H M2J M2K M2L M2M M2N M2P M2R M3A M3B M3C M3H M3J M3K M3L M3M M3N M4A M4B M4C M4E M4G M4H M4J M4K M4L M4M M4N M4P M4R M4S M4T M4V M4W M4X M4Y M5A M5B M5C M5E M5G M5H M5J M5K M5L M5M M5N M5P M5R M5S M5T M5V M5W M5X M6A M6B M6C M6E M6G M6H M6J M6K M6L M6M M6N M6P M6R M6S M7A M7R M7Y M8V M8W M8X M8Y M8Z M9A M9B M9C M9L M9M M9N M9P M9R M9V M9W'.split(' '));
const norm = v => v.toUpperCase().replace(/\s/g, '');
const validPostal = v => /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z]\d[ABCEGHJ-NPRSTV-Z]\d$/.test(v);
const postal = $('#lf-postal'), status = $('#lf-postal-status'), gated = $$('[data-gated]', root);
const stat = $('#lf-pack-status'), progress = $('#lf-progress'), add = $('#lf-add'), full = $('#lf-full');
const flavours = $$('[data-flav]', root).map(r => r.dataset.flav);
const counts = Object.fromEntries(flavours.map(f => [f, 0]));
let ok = '', pack = { size: 5, handle: '5-smoothie-trial', label: '5-smoothie trial' };
const total = () => Object.values(counts).reduce((a, b) => a + b, 0);
/* Subscriptions use the product that carries the Joy plan. Change this handle if the plan moves to another product. */
const SUB_HANDLE = '20-smoothie-box';
const orderRadios = $$('input[name="lf-order-type"]', root);
const subRadio = $('input[value="subscribe"][name="lf-order-type"]', root);
const onceRadio = $('input[value="once"][name="lf-order-type"]', root);
const freq = $('#lf-joy-frequency');
const details = $('#lf-joy-sub-details');
const choiceRoot = $('#lf-joy-choice');
const availability = document.createElement('p');
availability.id = 'lf-joy-unavailable';
availability.setAttribute('role','status');
choiceRoot.appendChild(availability);
let joyPlans = {};
let joyLoaded = false;
let subVariant = null;
const isSub = () => pack.size === 20 && !!subRadio.checked;
function matchPlan(plan, weeks) {
  const fields = [plan.name, plan.description, ...(plan.options || []).map(o => typeof o === 'string' ? o : o.value)].filter(Boolean).join(' ').toLowerCase();
  const found = fields.match(/(?:every[ ]*)?(2|4|6|8)[ ]*weeks?/i);
  if (!found || Number(found[1]) !== Number(weeks)) return false;
  const adjustments = plan.price_adjustments || [];
  return adjustments.some(a => a.value_type === 'fixed_amount' && Number(a.value) === 1000);
}
async function loadJoyPlans() {
  joyLoaded = false; joyPlans = {};
  try {
    const response = await fetch(`/products/${SUB_HANDLE}.js`, {credentials:'same-origin'});
    if (!response.ok) throw new Error('Product lookup failed');
    const product = await response.json();
    subVariant = product.variants && product.variants[0] ? product.variants[0].id : null;
    (product.selling_plan_groups || []).forEach(g => (g.selling_plans || []).forEach(p => {
      for (const w of [2,4,6,8]) if (matchPlan(p,w)) joyPlans[w] = p.id;
    }));
  } catch(e) { /* Leave subscriptions disabled when plans cannot be verified. */ }
  joyLoaded = true; render();
}
function updateOrderChoice() {
  if (pack.size === 5) { onceRadio.checked = true; subRadio.disabled = true; }
  else subRadio.disabled = false;
  details.hidden = !isSub();
  render();
}
function setLock(unlocked) {
  gated.forEach(el => { el.classList.toggle('lf-locked', !unlocked); if (unlocked) el.removeAttribute('inert'); else el.setAttribute('inert', ''); });
  const note = $('#lf-locked-note'); if (note) note.hidden = unlocked;
}
function render() {
  const n = total(), left = pack.size - n;
  $$('[data-count]', root).forEach(o => o.textContent = counts[o.dataset.count]);
  $$('[data-adjust]', root).forEach(b => b.disabled = Number(b.dataset.adjust) < 0 ? counts[b.dataset.flavour] === 0 : left === 0);
  $$('[data-handle]', root).forEach(b => b.setAttribute('aria-pressed', String(b.dataset.handle === pack.handle)));
  stat.textContent = `${n} of ${pack.size} chosen. ${left ? left + ' more to choose.' : 'Your box is full.'}`;
  progress.max = pack.size; progress.value = n;
  const subscriptionSelected = isSub();
  const validPlan = subscriptionSelected && !!joyPlans[freq.value] && !!subVariant;
  availability.hidden = !subscriptionSelected || !!validPlan;
  availability.textContent = joyLoaded ? 'Subscriptions are not available right now. Choose one-time purchase, or email kim@livingfarmacy.com.' : 'Checking subscription availability…';
  add.disabled = !(ok && left === 0) || (subscriptionSelected && !validPlan);
  add.textContent = !ok ? 'Check your postal code first' : left ? `Choose ${left} more` : subscriptionSelected ? (validPlan ? 'Go to subscription checkout' : 'Subscription checkout unavailable') : 'Go to Shopify checkout';
  const chosen = flavours.filter(f => counts[f] > 0);
  full.innerHTML = chosen.length ? chosen.map(f => { const row = $(`[data-flav="${f}"]`, root); return `<p><strong>${row.dataset.name} (${counts[f]})</strong>${row.dataset.ingredients}</p>`; }).join('') : '<p>Choose a flavour to see its full ingredient list.</p>';
}
function check() {
  const v = norm(postal.value); ok = '';
  if (!validPostal(v)) { status.dataset.ok = 'false'; status.textContent = 'Enter a full Canadian postal code, for example M5V 2T6.'; }
  else if (!FSA.has(v.slice(0, 3))) { status.dataset.ok = 'false'; status.textContent = 'Sorry, we do not deliver to this postal code yet. We deliver across the Greater Toronto Area. Email kim@livingfarmacy.com and we will see what we can do.'; }
  else { ok = v; postal.value = v.slice(0, 3) + ' ' + v.slice(3); status.dataset.ok = 'true'; status.textContent = 'We deliver to you. Shipping is free in the GTA.'; }
  setLock(!!ok); render();
}
postal.addEventListener('input', () => { ok = ''; status.dataset.ok = ''; status.textContent = ''; setLock(false); render(); });
postal.addEventListener('keydown', e => { if (e.key === 'Enter') { e.preventDefault(); check(); } });
$('#lf-postal-check').addEventListener('click', check);
root.addEventListener('click', e => {
  const p = e.target.closest('[data-handle]'), a = e.target.closest('[data-adjust]');
  if (p && !p.disabled) { if (p.dataset.handle !== pack.handle) flavours.forEach(f => counts[f] = 0); pack = { size: Number(p.dataset.size), handle: p.dataset.handle, label: p.dataset.label }; updateOrderChoice(); }
  if (a && !a.disabled) { counts[a.dataset.flavour] += Number(a.dataset.adjust); render(); }
});
$('#lf-mix').addEventListener('click', () => { flavours.forEach(f => counts[f] = pack.size / 5); render(); });
add.addEventListener('click', async () => {
  if (add.disabled || (isSub() && !joyPlans[freq.value])) return;
  add.disabled = true; add.textContent = 'Taking you to checkout…';
  try {
    const handle = isSub() ? SUB_HANDLE : pack.handle;
    const prod = await (await fetch(`/products/${handle}.js`)).json();
    const mix = flavours.filter(f => counts[f] > 0).map(f => `${$(`[data-flav="${f}"]`, root).dataset.name} x${counts[f]}`).join(', ');
    const item = {id:prod.variants[0].id,quantity:1,properties:{'Flavour mix':mix}};
    if (isSub()) item.selling_plan = joyPlans[freq.value];
    await fetch('/cart/clear.js', { method: 'POST' });
    const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [item] }) });
    if (!res.ok) throw new Error('add');
    await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { 'Delivery postal code': ok } }) });
    location.href = '/checkout';
  } catch (err) { status.dataset.ok = 'false'; status.textContent = 'We could not start your checkout. Please try again or email kim@livingfarmacy.com.'; render(); }
});
orderRadios.forEach(r => r.addEventListener('change', updateOrderChoice));
freq.addEventListener('change', render);
setLock(false); updateOrderChoice(); loadJoyPlans();
})();
